import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["image", "content"]


  select(event) {
    const clickedContainer = event.currentTarget

    this.imageTargets.forEach((container, index) => {
      const isActive = container === clickedContainer

      container.classList.toggle("lg:w-2/3", isActive)
      container.classList.toggle("lg:w-1/3", !isActive)

      const img = container.querySelector("img")
      img.classList.toggle("lg:blur-[20px]", !isActive)

      if (this.contentTargets[index]) {
        this.contentTargets[index].classList.toggle("lg:hidden", !isActive)
      }
    })
  }
}
